import { Gig, MusicFestivalFilter, VenueAndGig } from "../../../types/MusicFestivalTypes";

export const filterMusicFestVenuesAndGigs = (gigData: Gig[], filter: MusicFestivalFilter) => {

  // let venues = venueData.filter((venue) => (venue.title.toLowerCase().includes(filter.search.toLowerCase())))
  // let gigs = gigData.filter((gig) => gig.eventName.toLowerCase().includes(filter.search.toLowerCase()))

  // FILTERING BY SEARCH
  let gigs = gigData.filter((gig) => {
    if (gig.eventName.toLowerCase().includes(filter.search.toLowerCase())){ // searches gigs
      return true
    } 
    else return false
  })
  // console.log(filter.search, gigs)

  // FILTERING BY VENUE
  if (filter.location.length !== 0){
    gigs = gigs.filter((gig) => (filter.location.includes(gig.locations[0].title)))
  }
  // console.log(filter.search, gigs)

  // FILTERING BY GENRE
  if (filter.genre.length !== 0){
    gigs = gigs.filter((gig) => (gig.tags.some((tag) => filter.genre.includes(tag.name))))
  }
  // console.log(filter.search, gigs)

  // COMBINING VENUES AND GIGS
  let venuesAndGigs: VenueAndGig[] = []
  for (const gig of gigs){
    let notRegistered = true // boolean to determine if the venue of a gig is contained within the venuesAndGigs array
    // checks if the venue of the gig has been added to the array of venuesAndGigs
    for (let venueAndGig of venuesAndGigs){
      // venue has been found in the array so the gig is append to the gigs array within the corresponding object
      if (venueAndGig.venue.id === gig.locations[0].id){
        venueAndGig.gigs.push(gig)
        notRegistered = false
        break // leave for loop when found
      }
    }
    // venue is not registered in the venuesAndGigs array so a new object is appended with prefilled data
    if (notRegistered){
      venuesAndGigs.push({
        venueName: gig.locations[0].title,
        venue: gig.locations[0],
        gigs: [gig]
      })
    }
    
  }
  // console.log(venuesAndGigs)
  return venuesAndGigs
}